export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SET_USER_DATE_RANGE = "SET_USER_DATE_RANGE";
export const SET_USER_ACCESS = "SET_USER_ACCESS";
export const RESET_USER_STATE = "RESET_USER_STATE";
export const RESET_STATE = "RESET_STATE";